<nav id="nav" class="navbar">
  <div id="logo-container">
    <a
      [routerLink]="['/']"
      aria-label="Startsiden"
      routerLinkActive="router-link-active"
      >
      <svg
        id="header-small"
        #logo
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 240.9 211.7"
        alt="Startside"
        >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#fff"
          d="M48.8 210.8l2.3-5.7c1.4-3.3 3-6.5 4.5-9.7l.6-1.4h-2a87 87 0 01-30.3-5c-7.5-3-14-7.2-18.6-14a28 28 0 01-5-14.4l-.3-1.3v-3l.5-3.8c1-8.5 4.6-15.7 10.7-21.7 5.5-5.5 12-9.7 18.7-13.5 12-6.8 25-11.7 38-16.3 4.6-1.6 9.3-3 13.5-5.5 1.2-.7 2.4-1.6 3.5-2.5 2.8-2.4 3.8-5.5 2.6-9-.9-2.5-2.2-4.9-3.4-7.2-1.3-2.4-2.8-4.6-4.2-6.9-.4-.7-1-1-1.7-1a37 37 0 01-15-4 25 25 0 01-12.7-18.5A24.1 24.1 0 0157 24.9c5.4-6 12.1-9.9 19.3-13.1A154.7 154.7 0 01127.6.5c6.3-.3 12.7-.7 19-.4 7.5.3 15 1 22.4 1.8A167 167 0 01214 13.7c9.2 3.9 17.8 8.7 25.6 14.9.4.3 1 .6 1 1 .3.5.3 1.3 0 1.7-.2.3-1.1.4-1.6.2-.6 0-1-.6-1.5-1-11-8.5-23.3-14.3-36.4-18.7-10-3.2-20.1-5.6-30.6-7a229.4 229.4 0 00-35.4-2c-17.4.4-34.5 2.8-51 8.8a70.2 70.2 0 00-21 11.3c-4.3 3.6-7.9 7.8-9.5 13.4a23 23 0 0014 27.4c2.8 1 5.8 1.5 8.7 2.2h1.3l-.6-2.7c-1-6 1-11 5.1-15.2 4.7-5 10.3-8.8 16.4-12 9.4-5 19.5-8.5 30-10.5 5-1 10-1.4 15-1 4.7.4 9.1 1.6 13.3 3.9 5.4 3 6.6 7.6 4.2 13.4-1.7 4.2-5 6.9-9 8.7a340 340 0 01-17 7c-10.5 4.1-21.2 7.5-32.3 9.6-2.2.5-4.4.8-6.6 1.1l-1.6.4.7 1.2 4 6.4a14 14 0 011.7 6c.2 2.1-.6 3.9-1.9 5.5a27.2 27.2 0 01-12.4 8.6c-5.8 2.1-11.8 4-17.7 6-9.4 3.1-18.6 6.5-27.2 11.3A64 64 0 0024.3 127a36.5 36.5 0 00-9.6 21.5c-.5 6.2.1 12.2 2.2 18 2.8 8 8.5 13.3 15.8 17.2a50 50 0 0017.2 5.4l7.3.8c.8.1 1.2-.1 1.6-.8a233.9 233.9 0 0177.6-78.3c6.5-3.8 13.2-7.1 20.7-8.7 3.7-.7 7.4-1.2 11.1-.4 5 1 7.9 4.7 8.1 9.8.5 9-2.5 17-7.3 24.4a88.5 88.5 0 01-19 20.7 174.6 174.6 0 01-72.3 34.7c-6 1.3-12 2-18.1 2.5-.5 0-1.1.4-1.3.8l-7 16.3c-.2.3-.2.7-.4.8m10-21.5H62c6.2 0 12.3-.5 18.4-1.7 9.7-2 19-5 28-8.8 16.1-7 30.6-16.2 42.8-28.9a61 61 0 0012.9-18.9 26.6 26.6 0 002-16.3c-.7-3.3-2-6.1-5.6-7.2-1.5-.4-3-.7-4.6-.8-4.4-.3-8.6 1.1-12.6 2.7a115.9 115.9 0 00-28.6 17.6 230.5 230.5 0 00-53.2 61l-.7 1.3zM126.3 30c-1.7.2-5 .5-8.3 1-6.7 1.2-13 3.4-18.6 7.2-3.6 2.4-7 5.2-8.7 9.3a18.6 18.6 0 001.7 17.7c.2.3 1 .5 1.4.5 3.8-.6 7.6-1.2 11.3-2 16.5-3.7 32.2-9.5 47.5-16.5.5-.3 1.2-.9 1.2-1.5.7-2.4 0-4.7-1.6-6.5a21.9 21.9 0 00-4.4-3.8c-6-3.8-12.8-5.3-21.5-5.4z"
          />
        </svg>
      </a>
    </div>
    <button id="menu" aria-label="Åpne menyen" (click)="toggleMenu()">
      <div class="hamburger {{ visible ? 'open' : '' }}">
        <span></span>
        <span></span>
      </div>
    </button>
    <div id="nav-menu" [ngClass]="{ show: visible }">
      @if (menuLinks) {
        <div id="menu-links">
          <div id="main-categories">
            @for (category of menuLinks; track category; let i = $index) {
              <div
                id="main-category-{{ category.Id }}"
                class="main-category"
                (mouseover)="mainHover(category.Id)"
                (mouseleave)="mainLeave(category.Id)"
                >
                <a
                  class="link"
                  [routerLink]="['/' + category.Url]"
                  routerLinkActive="active"
                  (click)="closeMenu()"
                  >{{ category.Name }}</a
                  >
                </div>
              }
              <div
                id="main-category-79"
                class="main-category"
                (mouseover)="mainHover(79)"
                (mouseleave)="mainLeave(79)"
                >
                <a
                  class="link"
                  [routerLink]="['/nyheter']"
                  routerLinkActive="active"
                  (click)="closeMenu()"
                  >Event-uelt</a
                  >
                </div>
                <div
                  id="main-category-80"
                  class="main-category"
                  (mouseover)="mainHover(80)"
                  (mouseleave)="mainLeave(80)"
                  >
                  <a
                    class="link"
                    [routerLink]="['/om-oss']"
                    routerLinkActive="active"
                    (click)="closeMenu()"
                    >Hvem er vi</a
                    >
                  </div>
                  <div id="main-category-81" class="main-category">
                    <a
                      class="link"
                      [routerLink]="['/kontakt-oss']"
                      routerLinkActive="active"
                      (click)="closeMenu()"
                      >Kontakt oss</a
                      >
                    </div>
                    <div id="main-category-82" class="main-category">
                      <a
                        class="link"
                        [routerLink]="['/baerekraft']"
                        routerLinkActive="active"
                        (click)="closeMenu()"
                        >Bærekraft</a
                        >
                      </div>
                    </div>
                    @if (!isMobile && !isTablet) {
                      <div id="sub-categories">
                        @for (category of menuLinks; track category; let i = $index) {
                          <div
                            id="sub-category-{{ category.Id }}"
                            class="sub-category-wrapper"
                            >
                            <div class="bg"></div>
                            @for (subCategory of category.SubCategories; track subCategory) {
                              <div
                                class="sub-category"
                                >
                                <a
                                  class="link"
                                  [routerLink]="['/' + subCategory.Url]"
                                  routerLinkActive="active"
                                  (click)="closeMenu()"
                                  >{{ subCategory.Name }}</a
                                  >
                                </div>
                              }
                            </div>
                          }
                          @if (!isMobile && !isTablet) {
                            <div id="sub-category-79" class="sub-category-wrapper">
                              <div class="bg"></div>
                            </div>
                            <div id="sub-category-80" class="sub-category-wrapper">
                              <div class="bg"></div>
                              @for (subCategory of contactLinks; track subCategory) {
                                <div
                                  class="sub-category"
                                  >
                                  <a
                                    class="link"
                                    [routerLink]="['/' + subCategory.split(':')[1]]"
                                    routerLinkActive="active"
                                    (click)="closeMenu()"
                                    >{{ subCategory.split(":")[0] }}</a
                                    >
                                  </div>
                                }
                              </div>
                            }
                            <!-- <div id="sub-category-90" class="sub-category-wrapper" *ngIf="isMobile || isTablet">
                            <div class="sub-category">
                              <a class="link" [routerLink]="['/om-oss']" routerLinkActive="active" (click)="closeMenu()">Om oss</a>
                            </div>
                          </div> -->
                        </div>
                      }
                    </div>
                  }
                </div>
              </nav>
